// useSegmentsStatus — hook للاشتراك في حالة تحميل تعريفات الشرائح.
// v200.33 · Explicit failure UI — لا يعرض قرار افتراضياً عند الفشل.
import { useEffect, useState } from "react";
import {
  getSegmentsStatus,
  subscribeSegmentsStatus,
  retrySegmentsLoad,
} from "./segmentation";

export function useSegmentsStatus() {
  const [state, setState] = useState(() => getSegmentsStatus());
  useEffect(() => subscribeSegmentsStatus(setState), []);
  return { ...state, retry: retrySegmentsLoad };
}
